import { Reveal } from "@/components/Reveal";

export default function PageHero({ eyebrow, title, description, description2, icons, image, alt, photo, photoAlt, photoCaption }) {
  return (
    <section className="relative overflow-hidden bg-slate-50" data-testid="page-hero">
      {image && (
        <>
          <img src={image} alt={alt || ""} className="absolute inset-0 h-full w-full object-cover opacity-[0.07] img-duotone" />
          <div className="absolute inset-0 bg-gradient-to-b from-white/50 via-slate-50/80 to-slate-50" aria-hidden="true" />
        </>
      )}
      <div className="absolute -right-32 -top-32 h-96 w-96 rounded-full bg-teal-light blur-3xl opacity-70" aria-hidden="true" />
      <div className="container-arms relative py-24 lg:py-36">
        <Reveal>
          <p className="eyebrow mb-5">{eyebrow}</p>
          <h1 className="max-w-4xl text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.08] text-navy">{title}</h1>
          {description && (
            <p className="mt-6 max-w-2xl text-base sm:text-lg text-slate-600 leading-relaxed flex items-start gap-3">
              {icons?.[0]}
              <span>{description}</span>
            </p>
          )}
          {description2 && (
            <p className="mt-4 max-w-2xl text-base sm:text-lg text-slate-600 leading-relaxed flex items-start gap-3">
              {icons?.[1]}
              <span>{description2}</span>
            </p>
          )}
          {photo && (
            <div className="mt-10 max-w-xs">
              <img
                src={photo}
                alt={photoAlt || ""}
                loading="lazy"
                data-testid="page-hero-photo"
                className="w-full rounded-3xl object-cover shadow-2xl"
              />
              {photoCaption && (
                <p data-testid="page-hero-photo-caption" className="mt-3 text-center text-sm font-bold italic leading-relaxed text-teal">
                  {photoCaption}
                </p>
              )}
            </div>
          )}
        </Reveal>
      </div>
    </section>
  );
}
